import { getAllInstancesByName, getAnyInstancesByElement, initialiseComponents } from "../../../../core";
import Component from "../../../component.abstract";
import { notifyUser } from "../../../helpers/notifs";
import NavElement from "../../navigation/nav-element";

export default class ProfileContainer extends Component {
    private forms: Array<HTMLElement> = [];
    public currentForm: HTMLElement;

    constructor (
        readonly props: unknown,
        element: HTMLElement
    ) {  
        super(props, element)
    }

    mounted(): void {

        PubSub.subscribe("nav-element.selected", (msg: string, navElement: NavElement) => {
            this.handleSelected(navElement);     
        });

        PubSub.subscribe("nav-element-loaded", () => {
            const navElementInstances: Array<NavElement> = getAllInstancesByName("NavElement");
            navElementInstances.forEach(instance => {
            // If not anchor detected in URL return
            if (location.href.indexOf("#") === -1) return;

            // There is an anchor, now mach it with the right navElement
            const url = location.href;
            const anchor = url.substring(url.indexOf("#") + 1);
            
            if (instance.props.anchor === anchor) {
                this.handleSelected(instance);
            }
        });
        })
       
    }

    // Display selected form
    handleSelected(navElement: NavElement): void {
        if (!navElement.props.attribute) {
            return;
        }

        // Make sure everything was saved before leaving form
        if (this.currentForm) {
            // TODO: Replace any by form types
            const formInstances = <Array<any>> getAnyInstancesByElement(this.currentForm);
            formInstances.forEach(formInstance => {
                if (formInstance.isDirty && formInstance.isDirty())  {
                    notifyUser({
                        "title": "Avant de quitter la page, pensez à sauvegarder !",
                        "messages": ["Vous avez modifié des informations, cliquez sur « j’enregistre » pour les ajouter à votre compte."],
                        "okButton": "J'enregistre",
                        "okCallback": () => {
                            // Save & stay
                            formInstance.save();

                            // Add tracking event on save from popin
                            if (formInstance.props.trackingsClick && formInstance.props.trackingsClick.length){
                                window.dataLayer.push(formInstance.props.trackingsClick[1])
                            }
                            
                        },
                        "cancelButton": "Annuler",
                        "cancelCallback": () => {
                            // Quit without saving
                            this.displayForm(navElement);

                            // Add tracking event on cancel from popin
                            if (formInstance.props.trackingsClick && formInstance.props.trackingsClick.length) {
                                if (document.querySelector(".hasCancel")) {
                                    window.dataLayer.push(formInstance.data.trackingsClick[2])
                                }
                            }   
                        }
                    });
                } else {
                    // Form data wasn't changed
                    this.displayForm(navElement);
                }
            });
        } else {
            this.displayForm(navElement);
        }
    }

    displayForm(navElement: NavElement): void {
        // Update navigation element
        navElement.select();
        this.element.parentElement.querySelector('[data-profile-informations]').classList.add('md-hidden');

        // Check if form is already in the DOM
        let form: HTMLElement;
        this.forms.forEach(f => {
            if (f.hasAttribute(navElement.props.attribute)) {
                form = f;
                f.classList.remove("hidden");
            } else {
                // Hide the other forms
                f.classList.add("hidden");
            }
        });

        if (!form) {
            // If form is not already here, create it
            form = document.createElement("div");
            const attribute = navElement.props.url ? '{"url":"' + navElement.props.url + '"}' : "";
            form.setAttribute(navElement.props.attribute, attribute);
            form.classList.add("profile-form", "pending");
            this.element.appendChild(form);
            this.forms.push(form);

            initialiseComponents();
        } else {
            // Otherwise, reload data
            const formInstances = <Array<any>> getAnyInstancesByElement(form);
            formInstances.forEach(instance => {
                instance.call();
            });
        }

        this.currentForm = form;
        this.element.classList.add('profile-form--visible');
        window.location.hash = '#' + navElement.props.anchor;
    }
}